module.exports = __webpack_public_path__ + "img/Game_target_Z-09.ed296c84.png";